import { ErrorHandler, Injectable } from '@angular/core';

// This service is used to handle global errors in the application and log them to the console and perform custom error handling logic if needed.

@Injectable()
export class WKErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    console.error('Global Error:', error);
    //TODO: Perform custom error handling logic here
  }
}
